import type { SpecTable as SpecTableData } from '@/content/platform';

/**
 * 规格表。第一列通常是键名或状态码，用等宽字体；
 * 窄屏允许横向滚动而不是折行，因为折行后的字段名更难读。
 */
export function SpecTableView({
  table,
  className,
  firstColumnMono = true,
}: {
  table: SpecTableData;
  className?: string;
  /** 第一列是键名或状态码时用等宽字体；是中文标签时关掉更耐读。 */
  firstColumnMono?: boolean;
}) {
  return (
    <div className={['w-full min-w-0 overflow-hidden rounded-xl border border-line bg-surface-1', className].filter(Boolean).join(' ')}>
      <div className="overflow-x-auto">
        <table className="w-full min-w-[34rem] border-collapse text-sm">
          <thead>
            <tr className="border-b border-line bg-surface-2">
              {table.head.map((cell) => (
                <th key={cell} scope="col" className="px-4 py-2.5 text-left text-xs font-semibold text-fg">
                  {cell}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {table.rows.map((row, rowIndex) => (
              <tr key={rowIndex} className="border-b border-line last:border-b-0">
                {row.map((cell, cellIndex) => (
                  <td
                    key={cellIndex}
                    className={[
                      'px-4 py-3 align-top leading-relaxed',
                      cellIndex === 0
                        ? firstColumnMono
                          ? 'metric-value text-[0.8125rem] text-fg'
                          : 'font-medium text-fg'
                        : 'text-fg-muted',
                    ].join(' ')}
                  >
                    {cell}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
